import * as actionTypes from './actionTypes';

export const storeLocation = location => ({
   type: actionTypes.STORE_LOCATION,
   location
});

export const removeLocation = () => ({
    type: actionTypes.REMOVE_LOCATION
});